import React from "react";
import '../../css/Deliver.css';

import processImg from "../../../assets/why-testops/process.jpg";
import processIcon from "../../../assets/why-testops/process-icon.png";

import teamImg from "../../../assets/why-testops/team.jpg";
import teamIcon from "../../../assets/why-testops/team-icon.png";

import valueImg from "../../../assets/why-testops/value.jpg";
import valueIcon from "../../../assets/why-testops/value-icon.png";

const Deliver = () => {
 const deliver = [
  {
    image: processImg,
    icon: processIcon,
    title: "Unified Test Management",
    description:
      "TestOps from Froth, driven by FrothAI, makes QA a breeze from test generation to reporting—facilitating the access of tests, data, defects, and insights from a single user-friendly dashboard."
  },
  {
    image: teamImg,
    icon: teamIcon,
    title: "Intelligent Automation with Low Coding Hassles",
    description:
      "Froth TestOps speeds testing with AI record/play, low-code tools, CI/CD integration, and BrowserStack reporting, cutting manual work and boosting test coverage for teams globally now all.",
  },
  {
    image: valueImg,
    icon: valueIcon,
    title: "Maximum Value, Minimal Cost",
    description:
      "Froth TestOps enables enterprise testing with powerful automation and seamless integrations—saving time, cutting costs, and eliminating tool sprawl.",
  },
];

  return (
    <section className="deliver-section">
      <h1 className="deliver-title text-center">
        Innovate, Automate, Elevate: Redefining AI-Driven TestOps
      </h1>

      <div className="container text-center">
        <p className="deliver-text">
          Froth TestOps turns testing into a business accelerator for leaders who are in need of high-quality results. The product radically changes the way teams deliver quality at speed by mixing automation, collaboration, and insight in every step of the DevOps journey. Being one of the most advanced <span className="highlight">AI Software Testing Tools</span>, Froth TestOps is a means for organizations to carry out their testing in a shorter time, while at the same time keeping accuracy and efficiency.
        </p>

        <p className="deliver-text">
          <span className="highlight">Froth TestOps</span> is the future of testing that aims at making your testing workflow more efficient. With its user-friendly interface and strong features, Froth TestOps is the perfect tool for your team to automate, manage tests, track defects, and ensure comprehensive coverage in a simple way.
        </p>

        <p className="deliver-text">
          No matter if you are running manual or automated tests,
          <span className="highlight"> Froth TestOps</span> equips you with the ways to optimize your testing process and collaborate efficiently with other ​‍​‌‍​‍‌​‍​‌‍​‍‌teams.
        </p>
      </div>

      <div className="container mt-4">
        <div className="row">
          {deliver.map((item, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index}>
              <div className="deliver-card">
                <div className="image-wrapper">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-img-top"
                  />

                  <div className="icon-circle">
                    <img src={item.icon} alt="icon" />
                  </div>
                </div>

                <div className="card-body text-center">
                  <h5 className="card-titles">{item.title}</h5>
                  <p className="card-texts">{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Deliver;